/**!
 * Created by Leonardo Cheslacki on 14/03/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

module.exports.scene = {
    layerActions: {
        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Dashboard: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const studentDashboard = AllTap.$studentDashboard({current_name: current_name});

                studentDashboard.initDashboard();
            });
        },
        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Profile:  (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const studentProfile = AllTap.$studentProfile({current_name: current_name});

                studentProfile.initProfile();
            });
        },
        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01Library: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const studentLibrary = AllTap.$studentLibrary({current_name: current_name});

                studentLibrary.initLibrary();
            });
        },

        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01LibraryFiles: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const studentLibrary = AllTap.$studentLibrary({current_name: current_name});

                studentLibrary.initFiles();
            });
        },

        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01LibraryAudios: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const studentLibrary = AllTap.$studentLibrary({current_name: current_name});

                studentLibrary.initAudios();
            });
        },

        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01LibraryVideos: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const studentLibrary = AllTap.$studentLibrary({current_name: current_name});

                studentLibrary.initVideos();
            });
        },

        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01LibraryVideosPlayer: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const studentLibrary = AllTap.$studentLibrary({current_name: current_name});

                studentLibrary.initVideosPlayer();
            });
        },

        /**
         * this.window = window;
         * const StageClass = window.StageClass;
         * StageClass.sun.scene.layerActions.frame01(this, 'current_name');
         * @param _this
         * @param current_name
         */
        frame01SchoolFiles: (_this, current_name) => {
            /**
             *
             *  @param object
             *  Set "this", object of canvas CreateJs.
             */
            AllTap.setState({...AllTap.state, [`_this_${current_name}`]: _this}, () => {

                const studentSchool = AllTap.$studentSchool({current_name: current_name});

                studentSchool.initFiles();
            });
        },
    }
};

// module.exports.dashboard = {
//     progressAvatar: (_document, avatar, score) => {
//         const
//             helpersElement = AllTap.$helpersElement({document: _document}),
//             progress_avatar = helpersElement.getById('progress_avatar'),
//             helpersResize = AllTap.$helpersResize({
//                 document: _document,
//                 dom_scales: [progress_avatar]
//             });
//
//         AllTap.progressAvatar(_document, avatar, score);
//
//         helpersResize.makeResponsive();
//
//         const redirect = () => {
//             AllTap.redirectRoute(`${location.protocol}//${location.host}/student/profile`);
//         };
//
//         /**
//          *
//          *  Add event in the button for profile.
//          */
//         AllTap.removeListener('click', 'click-button-profile', redirect, () => {
//             AllTap.addListener(progress_avatar, 'click', 'click-button-profile', redirect);
//         });
//     }
// };
//
// module.exports.profile = {
//     progressAvatar: (_document, avatar, score) => {
//         const
//             helpersElement = AllTap.$helpersElement({document: _document}),
//             helpersStyle = AllTap.$helpersStyle({document: _document}),
//             progress_avatar = helpersElement.getById('progress_avatar'),
//             modal_avatar = helpersElement.getById('modal_avatar'),
//             button_avatar = helpersElement.getAllClass('button-avatar'),
//             bootstrap_modal = (AllTap.isElement(modal_avatar) ? (new bootstrap.Modal(modal_avatar)) : null);
//
//         AllTap.progressAvatar(_document, avatar, score);
//
//         const modal = () => {
//             !AllTap.isEmpty(bootstrap_modal) && bootstrap_modal.show();
//         };
//
//         /**
//          *
//          * @param event
//          */
//         const close = (event) => {
//             AllTap.stopPropagation(event);
//
//             const {target, target: {nodeName, parentNode}} = event;
//
//             let element = target;
//
//             (nodeName === 'IMG') && (element = parentNode);
//
//             if (AllTap.isElement(element)) {
//                 AllTap.patchForm(`${location.protocol}//${location.host}/student/profile-avatar/${element.wantAttribute('id')}`, {profile: {id: element.wantAttribute('id')}}, {
//                     beforeSend: () => {
//
//                     },
//                     done: ({status, alert, errors, message, route, data}) => {
//                         if (Boolean(status)) {
//                             let
//                                 year_avatar = AllTap.verifyField(data, 'classrooms_years.year_avatar'),
//                                 file = AllTap.verifyField(data, 'classrooms_avatars.file'),
//                                 uri = `${location.protocol}//${location.host}/images/student/avatar/${year_avatar}/${file}`;
//
//                             helpersStyle.setStyle({
//                                 avatar: {
//                                     background: `url(${uri})`,
//                                     backgroundRepeat: 'no-repeat',
//                                     backgroundPosition: 'center',
//                                     backgroundColor: 'blueviolet',
//                                     backgroundSize: '184px 184px'
//                                 }
//                             });
//
//                             helpersStyle.create('progress-avatar');
//                         } else {
//                             console.log(errors);
//                         }
//                     },
//                     fail: (response) => {
//                         console.log(response);
//                     },
//                     always: () => {
//
//                     }
//                 });
//             }
//
//             !AllTap.isEmpty(bootstrap_modal) && bootstrap_modal.hide();
//         };
//
//         /**
//          *
//          *  Add event in the button for modal.
//          */
//         AllTap.removeListener('click', 'click-button-modal', modal, () => {
//             AllTap.addListener(progress_avatar, 'click', 'click-button-modal', modal);
//         });
//
//         if (AllTap.isArrayIf(button_avatar)) {
//             for (let i = 0; i < button_avatar.length; i++) {
//                 AllTap.removeListener('click', `click-button-avatar-${i}`, close, () => {
//                     AllTap.addListener(button_avatar[i], 'click', `click-button-avatar-${i}`, close);
//                 });
//             }
//         }
//     },
//     odometer: (_document, object) => {
//         for (let property of object) {
//             AllTap.odometer(_document, property);
//         }
//     }
// };
